import fetch from './fetch'

// 微型消防站
export function firehouse (data) {
  return fetch({
    url: '/platform/public/firehouse',
    method: 'post',
    data
  })
}
export function getarealist (query) {
  return fetch({
    url: '/common/area/getList',
    method: 'post',
    data: query
  })
}
// 维保单位
export function maintenance (query) {
  return fetch({
    url: '/platform/public/maintenance',
    method: 'post',
    data: query
  })
}
// 公告详情
export function announcementInfo (query) {
  return fetch({
    url: '/platform/public/announcementInfo',
    method: 'post',
    data: query
  })
}

// 公告列表
export function announcements (query) {
  return fetch({
    url: '/platform/public/list',
    method: 'post',
    data: query
  })
}
// 已接入服务商
export function serviceLists (query) {
  return fetch({
    url: '/platform/public/serviceList',
    method: 'post',
    data: query
  })
}
// 已接入建筑
export function buildingGroups (query) {
  return fetch({
    url: '/platform/public/buildingGroup',
    method: 'post',
    data: query
  })
}
// 已接入重点单位
export function importCompany (query) {
  return fetch({
    url: '/platform/public/importCompany',
    method: 'post',
    data: query
  })
}
// 查看详情
export function details (query) {
  return fetch({
    url: '/platform/public/detail',
    method: 'post',
    data: query
  })
}
// 建筑管理单位
export function manage (query) {
  return fetch({
    url: '/platform/public/manage',
    method: 'post',
    data: query
  })
}
// 是否显示公众号
export function settingList (query) {
  return fetch({
    url: '/platform/public/settingList',
    method: 'post',
    data: query
  })
}
// 获取已接入服务商
export function buildingGroupSevice (data) {
  return fetch({
    url: '/platform/public/buildingGroupSevice',
    method: 'post',
    data: data
  })
}
// 获取服务商下面的系统
export function systemcard (query) {
  return fetch({
    url: '/platform/public/systemcard',
    method: 'get',
    params: query
  })
}
// 获取图片
export function getfile (query) {
  return fetch({
    url: '/common/file/getfile',
    method: 'post',
    data: query
  })
}
export function serverSystem (data) {
  return fetch({
    url: '/platform/public/serverSystem',
    method: 'post',
    data: data
  })
}
export function getSystem (data) {
  return fetch({
    url: '/platform/public/getSystem',
    method: 'post',
    data: data
  })
}

export function getWordbook (data) {
  return fetch({
    url: '/platform/public/getWordbook',
    method: 'post',
    data: data
  })
}

export function buildingReport (data) {
  return fetch({
    url: '/platform/public/buildReport',
    method: 'post',
    data: data
  })
}

// 通知列表
export function improveList (data) {
  return fetch({
    url: '/platform/improvement_announcement/list',
    method: 'post',
    data
  })
}
// 根据ID查询改进对象
export function findImproveObj(data) {
  return fetch({
    url: '/platform/public/getCompanyById',
    method: 'post',
    data
  })
}
// 修改通知
export function improveEdit(data) {
  return fetch({
    url: '/platform/improvement_announcement/edit',
    method: 'post',
    data
  })
}

// 查询详情
export function improveDetails (query) {
  return fetch({
    url: '/platform/improvement_announcement/detail',
    method: 'get',
    params: query
  })
}

export const wordbooksearch = (data) => {
  return fetch({
    url: '/common/wordbook/wordbooksearch',
    method: 'post',
    data: data
  })
}

export const rateArchivesDetail = (query) => {
  return fetch({
    url: '/admin/qualityscore/rateArchivesDetailGov',
    method: 'get',
    params: query
  })
}

export const rateArchives = (query) => {
  return fetch({
    url: '/admin/qualityscore/rateArchivesGov',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/gov.js